/**
 * Mixin for vue-summernote that attaches the ImageWrapperManager
 * to the Summernote editor instance after it is mounted.
 *
 * This mixin ensures that any custom image handling logic
 * is applied to the editor once it is fully initialized.
 *
 * Key points:
 * - Uses $nextTick + setTimeout to wait for Summernote DOM initialization.
 * - Safe: only runs if the Summernote instance exists.
 * - Can be added to vue-summernote via component patching (extendSummernoteComponent).
 *
 * Usage:
 *   Inject this mixin into the vue-summernote component to automatically
 *   wrap images after editor mount.
 */

import { ImageWrapperManager } from './ImageWrapperManager';

export const imageWrapperMixin = {
    mounted() {
        // Wait until Vue DOM updates and Summernote has initialized
        this.$nextTick(() => {
            setTimeout(() => {
                const $editor = $(this.$el);
                const summernote = $editor.data('summernote');

                // Attach custom image wrapper logic if the editor exists
                if (summernote && typeof ImageWrapperManager === 'function') {
                    ImageWrapperManager(summernote);
                }
            }, 100); // Timeout ensures Summernote DOM is ready
        });
    }
};
